export default "__VITE_ASSET__q73lTfsd__"